import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "m9 16 .348-.24c1.465-1.013 3.84-1.013 5.304 0L15 16",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M8 7h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 7h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 7h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 11h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 11h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 11h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 22v-6.5m4 0V22", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Hotel";
const Hotel = memo(themed(Icon));
export {
  Hotel
};
//# sourceMappingURL=hotel.js.map
